import { render, staticRenderFns } from "./PaymentMethodGroup.vue?vue&type=template&id=44978524&scoped=true&"
import script from "./PaymentMethodGroup.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodGroup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodGroup.vue?vue&type=style&index=0&id=44978524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44978524",
  null
  
)

component.options.__file = "PaymentMethodGroup.vue"
export default component.exports